import { useState, useEffect } from "react";
import { ChevronLeft, ChevronRight, Star } from "lucide-react";

const testimonials = [
  {
    name: "Sofia M.",
    role: "Yoga teacher",
    quote: "I came in carrying ten years of grief in my shoulders. After three sessions with Farina, I cried, I laughed, and I finally exhaled. This work is sacred.",
    img: "https://images.unsplash.com/photo-1544005313-94ddf0286df2?w=200&q=80&auto=format&fit=crop",
    rating: 5,
  },
  {
    name: "Priya K.",
    role: "New mother",
    quote: "Having a session at home, with my baby asleep nearby, felt like the deepest gift. My back pain eased and my anxiety lifted. I feel like myself again.",
    img: "https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=200&q=80&auto=format&fit=crop",
    rating: 5,
  },
  {
    name: "Daniela R.",
    role: "Therapist",
    quote: "As someone who holds space for others, this was the first time I felt truly held. Farina's presence alone is medicine. Spinal Flow has changed my body.",
    img: "https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=200&q=80&auto=format&fit=crop",
    rating: 5,
  },
];

export default function Testimonials() {
  const [i, setI] = useState(0);
  const t = testimonials[i];

  useEffect(() => {
    const id = setInterval(() => setI((v) => (v + 1) % testimonials.length), 7000);
    return () => clearInterval(id);
  }, []);

  return (
    <section id="testimonials" className="py-24 md:py-32 relative grain">
      <div className="max-w-5xl mx-auto px-6 md:px-12 relative">
        <div className="text-center reveal mb-14">
          <p className="text-xs uppercase tracking-[0.25em] text-secondary mb-4">Transformation stories</p>
          <h2 className="font-serif text-4xl md:text-5xl">Held, heard, transformed.</h2>
        </div>

        <div className="reveal rounded-[40px] bg-background border border-border/60 p-10 md:p-16 text-center relative" data-testid="testimonial-card">
          <div className="flex justify-center gap-1 mb-6">
            {Array.from({ length: t.rating }).map((_, k) => (
              <Star key={k} size={16} className="fill-secondary text-secondary" />
            ))}
          </div>
          <p className="font-serif text-2xl md:text-3xl leading-relaxed italic text-foreground">
            "{t.quote}"
          </p>
          <div className="mt-10 flex items-center justify-center gap-4">
            <img src={t.img} alt={t.name} className="w-14 h-14 rounded-full object-cover border-2 border-secondary/40" />
            <div className="text-left">
              <div className="font-serif text-xl">{t.name}</div>
              <div className="text-xs uppercase tracking-[0.18em] text-muted-foreground">{t.role}</div>
            </div>
          </div>

          <div className="absolute inset-y-0 -left-3 md:-left-7 flex items-center">
            <button
              onClick={() => setI((v) => (v - 1 + testimonials.length) % testimonials.length)}
              className="w-11 h-11 rounded-full bg-background border border-border/60 hover:bg-card flex items-center justify-center"
              aria-label="Previous"
              data-testid="testimonial-prev"
            >
              <ChevronLeft size={18} />
            </button>
          </div>
          <div className="absolute inset-y-0 -right-3 md:-right-7 flex items-center">
            <button
              onClick={() => setI((v) => (v + 1) % testimonials.length)}
              className="w-11 h-11 rounded-full bg-background border border-border/60 hover:bg-card flex items-center justify-center"
              aria-label="Next"
              data-testid="testimonial-next"
            >
              <ChevronRight size={18} />
            </button>
          </div>
        </div>

        <div className="mt-6 flex justify-center gap-2">
          {testimonials.map((_, k) => (
            <button
              key={k}
              onClick={() => setI(k)}
              className={`h-1.5 rounded-full transition-all ${k === i ? "w-8 bg-secondary" : "w-3 bg-border"}`}
              aria-label={`Go to testimonial ${k + 1}`}
            />
          ))}
        </div>
      </div>
    </section>
  );
}
